import { useRutilusQuery } from '../../../../api/graphql/useRutilusQuery';
import { notEmpty } from '../../../../helpers/array';
import { getNodesFromConnection } from '../../../../helpers/graphql';
import {
  GetCatchPostComments,
  GetCatchPostCommentsVariables,
} from '../../../../interfaces/graphql';
import { IDisplayEntity } from '../../../../interfaces/post';
import { getCatchPostComments } from '../../../../queries/rutilus/Catch';
import { Post } from '../../types/Post';
import type { PostComment } from '../../types/PostComment';

interface PostCommentsData {
  postCommentContent: string;
  postCommentDate: Date;
  postComments: PostComment[];
  isLoading: boolean;
  likedByCurrentUser: boolean;
  likesCount: number;
  postId: string;
  userAvatarUrl: string;
  userFishingSpotAndFish: string[];
  userId: string;
  userNickname: string;
  displayEntity?: IDisplayEntity | null;
}

export const usePostComments = (
  posts: Post[],
  currentPostId: string | undefined,
): PostCommentsData => {
  const { data, loading: isLoading } = useRutilusQuery<
    GetCatchPostComments,
    GetCatchPostCommentsVariables
  >(getCatchPostComments, {
    variables: { externalId: currentPostId, first: 10 },
  });
  const currentPost = posts.find(post => post._id === currentPostId);
  const currentPostText = currentPost?.text;
  const postCommentContent = currentPostText?.text ?? '';
  const createdAt = currentPost?.createdAt;
  const postCommentDate = new Date(createdAt);
  const postComments = getNodesFromConnection(data?.post.comments);
  const likedByCurrentUser = !!data?.post.likedByCurrentUser;
  const likesCount = data?.post.likesCount ?? 0;
  const postId = currentPost?._id ?? '';
  const user = currentPost?.user;
  const userAvatarUrl = user?.avatar?.url ?? '';
  const catchData = currentPost?.catch;
  const fishingWaterName = catchData?.fishingWater?.displayName; // todo get fishingwater from post as well
  const speciesName = catchData?.species?.displayName;
  const userFishingSpotAndFish = [fishingWaterName, speciesName].filter(notEmpty);
  const userId = user?._id ?? '';
  const userNickname = user?.nickname ?? '';
  const displayEntity = currentPost?.displayEntity;

  return {
    postCommentContent,
    postCommentDate,
    postComments,
    displayEntity,
    isLoading,
    likedByCurrentUser,
    likesCount,
    postId,
    userAvatarUrl,
    userFishingSpotAndFish,
    userId,
    userNickname,
  };
};
